import { useState } from "react";

import { Radio } from "antd";
import classnames from "classnames";
import PropTypes from "prop-types";
import Label from "shared/components/Label";

const SimpleRadio = ({
  errors,
  touched,
  label,
  icon,
  onChange,
  values,
  value,
  required,
  optional,
  direction,
  disabled,
  size,
  type,
  ...rest
}) => {
  const [checkedValue, setCheckedValue] = useState(value);

  const onSelect = (e) => {
    setCheckedValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <div
      className={classnames(
        "input__wrapper",
        { __error: touched && errors },
        direction,
      )}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className="input__wrapper--field">
        <Radio.Group
          onChange={onSelect}
          value={checkedValue}
          defaultValue={value}
          disabled={disabled}
          size={size}
          className={classnames("simple-radio-group", {
            "simple-radio-group--primary": type === "primary",
            [`grid--${size}`]: size && type === "primary",
          })}
          {...rest}
        >
          {values.map(({ label: optionLabel, value: optionValue }) => (
            <Radio.Button value={optionValue} key={`radio-${optionValue}`}>
              {optionLabel}
            </Radio.Button>
          ))}
        </Radio.Group>
        {touched && errors && <p className="input--errors">{errors}</p>}
      </div>
    </div>
  );
};

SimpleRadio.propTypes = {
  errors: PropTypes.string,
  touched: PropTypes.bool,
  label: PropTypes.string,
  icon: PropTypes.node,
  onChange: PropTypes.func,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.any,
    }),
  ),
  value: PropTypes.any,
  required: PropTypes.bool,
  optional: PropTypes.bool,
  direction: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.number,
  type: PropTypes.oneOf(["primary", "default"]),
};

SimpleRadio.defaultProps = {
  onChange: () => {},
  values: [],
  direction: "column",
  disabled: false,
  type: "default",
};

export default SimpleRadio;
